import React from 'react';
import parse from 'html-react-parser';
import { useStyles } from "../styles/styles";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from '@mui/material/useMediaQuery'
import Typography from "@mui/material/Typography";
import Grid from '@mui/material/Grid';

export const HtmlComponent = (props) => {
    const title = props.title;
    const notice = props.notice;
    const component = props.component;
    const classes = useStyles;
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('lg'));

    return (
        <>
            <Typography variant={smallScreen ? 'h6' : 'h5'} sx={{ ...classes.title, marginTop: '1rem' }}>
                {title}
            </Typography>
            <Grid container spacing={0} sx={{
                justifyContent: "center"
            }}>
                {notice && (
                    <Grid component="div" sx={{ margin: '0 1.5em', marginTop: '1rem' }} size={12}>
                        <Typography variant="body1" color="secondary">
                            {parse(`${notice}`)}
                        </Typography>
                    </Grid>
                )}
                <Grid
                    component="div"
                    sx={{ margin: '0 1.5em', marginTop: notice ? '1rem' : '0' }}
                    size={12}>
                    {parse(`${component}`)}
                </Grid>
            </Grid>
        </>
    );
}